export const routes: { [key: string]: string } = {
  root: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  setPasswordAfterUpgrade: '/set-password-after-upgrade',
  firstTimeChangePassword: '/first-time-change-password',
  profile: '/profile',
  editProfile: '/profile',
  roleList: '/roles',
  addRole: '/role/add',
  editRole: '/role/editRole',
  privilige: '/role/privilige',
  users: '/users',
  agentList: '/agents',
  addAgent: '/agents/add',
  editAgent: '/agents/editAgent',
  budgetList: '/budget',
  addBudget: '/budget/add',
  editBudget: '/budget/editBudget',
  venueType: '/venueType',
  customerList: '/customer',
  addCustomer: '/customer/add',
  editCustomer: '/customer/editCustomer',
  rfqList: '/rfqList',
  viewRfq: '/rfqDetails',
  location: '/location',
  addOns: '/addOns',
  eventType: '/segment',
  roomType: '/roomType',
  templateSchedule: '/templateSchedule',
  editTemplateSchedule: '/templateSchedule/edit',
  taxCode: '/taxCode',
  taxGroup: '/taxGroup',
  surcharge: '/surcharge',
  layout: '/layout',
  systemMessage: '/systemMessage',
  editSystemMessage: '/systemMessage/edit',
  bookingMessage: '/bookingMessage',
  editBookingMessage: '/bookingMessage/edit',
  pricePackage: '/pricePackage',
  mailTemplate: '/mailTemplate',
  editMailTemplate: '/mailTemplate/edit',
  parentOrganization: '/parentOrganization',
  addParentOrganization: '/parentOrganization/add',
  editParentOrganization: '/parentOrganization/edit',
  rooms: '/rooms',
  addRooms: '/rooms/add',
  editRooms: '/rooms/edit',
  venue: '/venue',
  addVenue: '/venue/add',
  editVenue: '/venue/edit',
  paymentConfig: '/paymentConfiguration',
  addPaymentConfig: '/paymentConfiguration/add',
  editPaymentConfig: '/paymentConfiguration/edit',
  emailEventConfig: '/emailEventConfiguration',
  addEmailEventConfig: '/emailEventConfiguration/add',
  editEmailEventConfig: '/emailEventConfiguration/edit',
  //Bookings
  addBooking: '/new-booking',
  bookings: '/bookings',
  editBooking: '/Edit-Booking',
  bookingById: '/booking/:id',
  reports: '/reports',
  consolidatedReports: '/consolidate-reports',
  organization: '/organization',
  addOrganization: '/organization/add',
  editOrganization: '/organization/edit',
  dashboard: '/dashboard',
  venueConfiguration: '/venueConfiguration',
  addVenueConfiguration: '/venueConfiguration/add',
  bulkCreateVenueConfiguration: '/venueConfiguration/bulk-create',
  editVenueConfiguration: '/venueConfiguration/edit',
  bookingList: '/booking-list',
  bookingEventSource: '/booking-event-source',
  deletedBookings: '/deleted-bookings',
  orgMasterData: '/org-master-data',
  partOfDay: '/part-of-day',

  mealPlans: '/meal-plans',

  address: '/address',
  addAddress: '/address/add',
  editAddress: '/address/edit',

  addBeo: '/BEO/add',

  availableOrgs: '/available-organisations',
  availableVenues: '/available-venues',

  companyMasters: '/company-masters',
  addCompanyMasters: '/company-masters/add',
  editCompanyMasters: '/company-masters/edit',

  addFollowUp: 'follow-up/add',
  editFollowUp: 'follow-up/edit',
  taskList: '/task-list',

  salesManagement: '/sales-calls',
  addSalesManagement: '/sales-calls/add',
  editSalesManagement: '/sales-calls/edit',
  viewSalesManagement: '/sales-calls/view',
  salesReport: '/sales-report',
  paymentMethods: '/payment-methods',

  addOnCategories: '/add-on-categories',
  addOnCategoriesList: '/add-on-categories/page',

  industryType: '/industryType',

  // IDS Configurations
  idsConfigurations: '/ids-configurations',
  eventMappings: '/ids-configurations/event-mappings',
  venueMappings: '/ids-configurations/venue-mappings',
  layoutMappings: '/ids-configurations/layout-mappings',
  statusMappings: '/ids-configurations/status-mappings',
  idsLogs: '/ids-configurations/ids-logs',

  saBookingLookup: '/sa/booking-lookup',
  propertyOnboarding: '/sa/property-onboarding',
  propertyReadinessDashboard: '/sa/property-readiness',
  operaLogs: '/sa/opera-logs',
};

/** React Router pattern for super-admin line item edit (use with `:orderRef` and `:lineItemId`). */
export const SA_BOOKING_LINE_ITEM_EDIT_ROUTE = '/sa/booking-lookup/:orderRef/line-item/:lineItemId/edit';

export function saBookingLineItemEditPath(orderRef: string, lineItemId: string | number): string {
  return `/sa/booking-lookup/${encodeURIComponent(orderRef)}/line-item/${lineItemId}/edit`;
}
